import React, { useState } from "react";
import "../css/ActivitiesGallery.css";
// Sample images for each activity (replace with appropriate paths).
import ekadashi1 from "../asset/Events/Ashadi Ekadeshi/20240716_083436.jpg";
import ekadashi2 from "../asset/Events/Ashadi Ekadeshi/20240716_084935.jpg";
import ekadashi3 from "../asset/Events/Ashadi Ekadeshi/20240716_084957.jpg";
import ekadashi4 from "../asset/Events/Ashadi Ekadeshi/IMG-20240716-WA0008.jpg";
import ekadashi5 from "../asset/Events/Ashadi Ekadeshi/IMG-20240716-WA0011.jpg";
import ekadashi6 from "../asset/Events/Ashadi Ekadeshi/IMG-20240716-WA0015.jpg";
import ekadashi7 from "../asset/Events/Ashadi Ekadeshi/WhatsApp Image 2024-07-17 at 10.59.38 AM.jpeg";
import ekadashi8 from "../asset/Events/Ashadi Ekadeshi/WhatsApp Image 2024-07-17 at 10.59.43 AM.jpeg";
import ekadashi9 from "../asset/Events/Ashadi Ekadeshi/WhatsApp Image 2024-07-17 at 10.59.52 AM.jpeg";
import ekadashi10 from "../asset/Events/Ashadi Ekadeshi/WhatsApp Image 2024-07-17 at 10.59.53 AM.jpeg";

import first1 from "../asset/Events/first day of school/20240618_082720.jpg";
import first2 from "../asset/Events/first day of school/20240618_082727.jpg";
import first3 from "../asset/Events/first day of school/20240618_123329.jpg";
import first4 from "../asset/Events/first day of school/20240618_125357.jpg";
import first5 from "../asset/Events/first day of school/20240618_125407.jpg";
import first6 from "../asset/Events/first day of school/20240618_125738.jpg";
import first7 from "../asset/Events/first day of school/20240618_130544.jpg";
import first8 from "../asset/Events/first day of school/20240618_130549.jpg";
import first9 from "../asset/Events/first day of school/20240618_130557.jpg";
import first10 from "../asset/Events/first day of school/20240618_132850.jpg";

import guru1 from "../asset/Events/Gurupurnima/1721574146314.jpg";
import guru2 from "../asset/Events/Gurupurnima/1721574146319.jpg";
import guru3 from "../asset/Events/Gurupurnima/1721574146324.jpg";
import guru4 from "../asset/Events/Gurupurnima/1721574146330.jpg";
import guru5 from "../asset/Events/Gurupurnima/1721574146339.jpg";
import guru6 from "../asset/Events/Gurupurnima/1721574146347.jpg";
import guru7 from "../asset/Events/Gurupurnima/1721574146356.jpg";
import guru8 from "../asset/Events/Gurupurnima/1721574146364.jpg";
import guru9 from "../asset/Events/Gurupurnima/1721574146374.jpg";
import guru10 from "../asset/Events/Gurupurnima/1721574146383.jpg";

import indipendance1 from "../asset/Events/independence/1723773076269.jpg";
import indipendance2 from "../asset/Events/independence/1723773076273.jpg";
import indipendance3 from "../asset/Events/independence/1723773076397.jpg";
import indipendance4 from "../asset/Events/independence/1723773076502.jpg";
import indipendance5 from "../asset/Events/independence/1723773076534.jpg";
import indipendance6 from "../asset/Events/independence/1723773076538.jpg";
import indipendance7 from "../asset/Events/independence/1723773076559.jpg";
import indipendance8 from "../asset/Events/independence/1723773076626.jpg";
import indipendance9 from "../asset/Events/independence/1723773076630.jpg";
import indipendance10 from "../asset/Events/independence/1723773076633.jpg";

import sport1 from "../asset/Events/Sports 5to 7/1733150844922.jpg";
import sport2 from "../asset/Events/Sports 5to 7/1733150844944.jpg";
import sport3 from "../asset/Events/Sports 5to 7/1733150844972.jpg";
import sport4 from "../asset/Events/Sports 5to 7/1733150844999.jpg";
import sport5 from "../asset/Events/Sports 5to 7/1733150845022.jpg";
import sport6 from "../asset/Events/Sports 5to 7/1733150845043.jpg";
import sport7 from "../asset/Events/Sports 5to 7/1733150845066.jpg";
import sport8 from "../asset/Events/Sports 5to 7/1733150845089.jpg";
import sport9 from "../asset/Events/Sports 5to 7/1733150845111.jpg";
import sport10 from "../asset/Events/Sports 5to 7/1733150845133.jpg";

import teacher1 from "../asset/Events/Teachers day/1725553427782.jpg";
import teacher2 from "../asset/Events/Teachers day/1725553427804.jpg";
import teacher3 from "../asset/Events/Teachers day/1725553427819.jpg";
import teacher4 from "../asset/Events/Teachers day/1725553427833.jpg";
import teacher5 from "../asset/Events/Teachers day/1725553427849.jpg";
import teacher6 from "../asset/Events/Teachers day/1725553427868.jpg";
import teacher7 from "../asset/Events/Teachers day/1725553427888.jpg";
import teacher8 from "../asset/Events/Teachers day/1725553427916.jpg";
import teacher9 from "../asset/Events/Teachers day/1725553427950.jpg";
import teacher10 from "../asset/Events/Teachers day/1725553427967.jpg";

import yoga1 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.20 PM (1).jpeg";
import yoga2 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.12 PM (2).jpeg";
import yoga3 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.27 PM.jpeg";
import yoga4 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.04 PM.jpeg";
import yoga5 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.05 PM.jpeg";
import yoga6 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.06 PM.jpeg";
import yoga7 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.09 PM.jpeg";
import yoga8 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.13 PM.jpeg";
import yoga9 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.17 PM.jpeg";
import yoga10 from "../asset/Events/Yoga Day/WhatsApp Image 2024-06-21 at 6.52.20 PM.jpeg";

const Events = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const Events = [
    {
      title: "Ashadi Ekadashi",
      description:
        "Ashadi Ekadashi is celebrated with devotion, reflecting cultural and spiritual values. Students and staff come together for prayers and traditional activities to mark this auspicious day.",
      images: [
        ekadashi1,
        ekadashi2,
        ekadashi3,
        ekadashi4,
        ekadashi5,
        ekadashi6,
        ekadashi7,
        ekadashi8,
        ekadashi9,
        ekadashi10,
      ],
    },
    {
      title: "First Day of School",
      description:
        "The first day of school is filled with excitement and new beginnings, as students step into an enriching journey of learning, growth, and friendships.",
      images: [
        first1,
        first2,
        first3,
        first4,
        first5,
        first6,
        first7,
        first8,
        first9,
        first10,
      ],
    },
    {
      title: "Gurupurnima",
      description:
        "Gurupurnima is a day of gratitude and reverence, where students honor their teachers for their invaluable guidance and wisdom.",
      images: [
        guru1,
        guru2,
        guru3,
        guru4,
        guru5,
        guru6,
        guru7,
        guru8,
        guru9,
        guru10,
      ],
    },
    {
      title: "Indepandance Day",
      description:
        "Independence Day is celebrated with patriotic fervor, featuring flag hoisting, cultural programs, and a tribute to our nation's heroes.",
      images: [
        indipendance1,
        indipendance2,
        indipendance3,
        indipendance4,
        indipendance5,
        indipendance6,
        indipendance7,
        indipendance8,
        indipendance9,
        indipendance10,
      ],
    },
    {
      title: "Sports 5 to 7",
      description:
        "Sports events for Grades 5 to 7 foster teamwork, discipline, and enthusiasm among students, with a spirit of healthy competition and physical fitness.",
      images: [
        sport1,
        sport2,
        sport3,
        sport4,
        sport5,
        sport6,
        sport7,
        sport8,
        sport9,
        sport10,
      ],
    },
    {
      title: "Teachers Day",
      description:
        "Teachers’ Day is a heartfelt celebration where students express their appreciation and admiration for the dedication and contributions of their mentors.",
      images: [
        teacher1,
        teacher2,
        teacher3,
        teacher4,
        teacher5,
        teacher6,
        teacher7,
        teacher8,
        teacher9,
        teacher10,
      ],
    },
    {
      title: "Yoga Day",
      description:
        "Yoga Day promotes holistic well-being, with students and staff participating in guided yoga sessions to embrace health, mindfulness, and inner peace.",
      images: [
        yoga1,
        yoga2,
        yoga3,
        yoga4,
        yoga5,
        yoga6,
        yoga7,
        yoga8,
        yoga9,
        yoga10,
      ],
    },
  ];

  const openImage = (image) => {
    setCurrentImage(image);
    setIsOpen(true);
  };

  const closeImage = () => {
    setIsOpen(false);
    setCurrentImage(null);
  };

  return (
    <div className="activities-container">
      <h1 className="activities-head">Events Gallery</h1>
      <p className="activities-intro">
        "Step into our vibrant event gallery, a curated collection of moments
        that showcase creativity, collaboration, and celebration. From artistic
        endeavors to skill-building workshops, each event captures the joy of
        learning and the spirit of community. Experience the highlights of our
        diverse Events, where students and participants explore their passions,
        build memories, and grow together. Immerse yourself in the colors,
        energy, and smiles that make each event truly unforgettable."
      </p>
      {Events.map((activity, index) => (
        <div key={index} className="activity-section">
          <h2 className="activity-title">{activity.title}</h2>
          <p className="activity-description">{activity.description}</p>
          <div className="activity-gallery">
            {activity.images.map((image, idx) => (
              <div
                key={idx}
                className="activity-item"
                onClick={() => openImage(image)}
              >
                <img src={image} alt={`${activity.title} ${idx}`} />
              </div>
            ))}
          </div>
        </div>
      ))}

      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
            <img
              className="modal-image"
              src={currentImage}
              alt="Expanded view"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;
